<div class="row mx-0">
  <div class="col p-0">
    <select
      class="ag_grid_custom_dropdown cursorPointer ps-2"
      id="custom_select_options" 
      [(ngModel)]="value" 
      (ngModelChange)="selected($event)"
     >
      <option *ngFor="let val of values" [value]="val?.id">
        {{ val?.name }}
      </option>
    </select>
  </div>
</div>
